import anime from 'animejs/lib/anime.es.js'

document.addEventListener('DOMContentLoaded', () => {
	const footer = document.querySelector('footer')
	let footerHeight = footer.getBoundingClientRect().height
	document.body.setAttribute('style', `--footer-height: ${footerHeight}px;`)

	const divAnimation = anime({
		targets: 'footer *',
		elasticity: 200,
		easing: 'easeInOutCubic',
		autoplay: false,
		opacity: [0, 1],
	})

	const scrollPercent = () => {
		const docST = document.documentElement.scrollTop
		const docSH = document.documentElement.scrollHeight
		const docCH = document.documentElement.clientHeight

		return (
			(Math.max(0, docST - docSH + docCH + footerHeight) / footerHeight) * 100
		)
	}
	const screenSize = window.innerHeight
	const scrollHeight = document.documentElement.scrollHeight
	if (scrollHeight < screenSize + footerHeight) {
		divAnimation.seek(divAnimation.duration)
	}
	window.onscroll = () => {
		divAnimation.seek((scrollPercent() / 100) * divAnimation.duration)
	}

	window.addEventListener('resize', () => {
		footerHeight = footer.getBoundingClientRect().height
		document.body.setAttribute('style', `--footer-height: ${footerHeight}px;`)
	})
})
